<app-lfsa-card [innTemplate]="carga" [titulo]="titulo" [efecto]="true" [colapseName]="'carga'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #carga>
    <form [formGroup]="formulario" novalidate class="form-group">
      <div class="row">
        <div class="form-group col-md-4">
          <app-lfsa-combo-box-mult [mostrarImg]="false" [multiple]="false" [rutaImagen]="" (enviarOjeto)="obtenerObjetoVendedor($event)"
                [placeholder]="'Vendedor'" [opcion]="'tnama'" [idOpcion]="'temno'" [comboBox]="cmbVendedor"
                [label]="'Seleccione Vendedor'" [id]="'Vendedor'">
          </app-lfsa-combo-box-mult>
        </div>
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <div *ngIf="!loading" class="form-group col-md-4">
          <label for="">&nbsp;</label>
          <button [disabled]="formulario.invalid" class="btn btn-success btn-block" (click)="decargarFile()">Descargar</button>
        </div>
      </div>
    </form>
    <!-- {{ formulario.value | json}} -->
  </ng-template>